import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import TablatureXML from './TablatureXML';
import TablatureImage from './TablatureImage';
import NotationTabs from './NotationTabs';
import Flag from '../Flag';

const TablatureList = ({ settings, tabsList, isFullScreen, toggleFullScreen }) => (
  <div className="tablature-list">
    <ul className="list pl0 ma0">
      {tabsList.map(tab => (
        <li key={uuid()} className="mb3" role="presentation">
          {tab.type === 'xml' ? (
            <Flag
              name="isNotationEnabled"
              fallBack={<TablatureXML tabXML={tab.data} settings={settings} />}
            >
              <NotationTabs
                tabXML={tab.data}
                isFullScreen={isFullScreen}
                toggleFullScreen={toggleFullScreen}
              />
            </Flag>
          ) : (
            <TablatureImage image={tab.image} />
          )}
        </li>
      ))}
    </ul>
  </div>
);

TablatureList.propTypes = {
  settings: PropTypes.shape({}),
  tabsList: PropTypes.arrayOf(PropTypes.shape({})),
  isFullScreen: PropTypes.bool,
  toggleFullScreen: PropTypes.func,
};

TablatureList.defaultProps = {
  settings: null,
  tabsList: null,
  isFullScreen: false,
  toggleFullScreen: () => {},
};

export default TablatureList;
